import React, {Fragment, useEffect, useRef, useState} from "react";
import {Link, NavLink, useLocation, useParams} from "react-router-dom";
import '../../assets/css/home.css';
import axios from "axios";
import clientconfigwebapp, {
    Agent_by_user_get_appbk,
    check_login_appbk, empty_bk,
    FormatNumberByhkh,
    get_first_last_name_local, modal_select_agent_show_hide,
    scrollTo_uphk, Token_get_appbk
} from "../../clientconfigwebapp";
import {toast, ToastContainer} from "react-toastify";

import Master_Front from "../../pages/Master_Front";


import {Grid, Typography, Box, Container, Card, CardContent} from '@mui/material';




const Services = (props) => {
    const location_get_urlbk = useLocation();

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile, setData_first_name_profile] = useState('');
    const [last_name_profile, setData_last_name_profile] = useState('');
    /*  end profile */


    const [data_slider_list, set_data_slider_list] = useState([]);
    const [data_paged_info, set_data_paged_info] = useState([]);

    const imgBaseUrl = String(clientconfigwebapp.webappurl);


    useEffect(() => {

        Load_api_page();


    }, [location_get_urlbk]);


    const Load_api_page = () => {

        var config = null;
        scrollTo_uphk();

        if (check_login_appbk() == true) {
            config = {
                headers: {Authorization: `Bearer ${Token_get_appbk()}`}
            };
        }


        const data_form = null;

        axios.post(`${clientconfigwebapp.siteurl}api/v1/home-get-data/`, data_form, config)
            .then((res) => {


                if (String(res.data.data).length > 0) {


                    if (String(res.data.wallet_inventory).length > 0) {
                        setData_wallet_balance(res.data.wallet_inventory);
                    }
                    if (!empty_bk(res.data.first_name_profile)) {
                        setData_first_name_profile(res.data.first_name_profile);
                        localStorage.setItem('first_name_Get', res.data.first_name_profile);
                    }
                    if (!empty_bk(res.data.last_name_profile)) {
                        setData_last_name_profile(res.data.last_name_profile);
                        localStorage.setItem('last_name_Get', res.data.last_name_profile);
                    }


                } else {
                    if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }

            }).catch((err) => {
            /// Setloadinghkfullshow("false");
            toast.error('خطای اتصال به سرور کد 543534', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        });


    }


    return (


        <Fragment>

            <Master_Front wallet_balance={wallet_balance} first_name_profile={first_name_profile}
                          last_name_profile={last_name_profile}>

                <ToastContainer/>


                <style jsx>{`
                    .h1-aboutus {

                        font-size: 19px;
                        font-weight: bold;
                        display: block;
                        margin-bottom: 8px;
                        font-family: 'iran';
                        text-align: center;
                        padding-top: 38px;
                    }

                    .description-aboutus {
                        font-family: 'iran';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 13px;
                        line-height: 1.9;
                        text-align: justify;
                        color: #1F2937;
                    }


                    .aboutus_seca_right {
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        justify-content: center;
                        align-items: flex-start;
                    }

                    .aboutus_seca_left {
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        justify-content: center;
                        align-items: flex-end;
                    }

                    .aboutus_seca_left img {
                        width: 68% !important;
                    }


                    .aboutus_title_main_section_b {
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        justify-content: center;
                        align-items: center;
                        font-size: 19px;
                        font-weight: bold;
                        color: black;
                        margin-bottom: 8px;
                        margin-top: 55px;
                    }


                    .aboutus_section_b_desc {
                        text-align: center;
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        align-content: center;
                        margin-bottom: 71px;
                        padding-right: 30%;
                        padding-left: 30%;
                        line-height: 1.6;
                        font-size: 14px;
                        color: #1F2937;
                    }


                    .card_box_about_us_services {
                        box-sizing: border-box;
                        height: 313px;
                        border: 0.5px solid #9CA3AF;
                        backdrop-filter: blur(4px);
                        border-radius: 13px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        padding-top: 36px;
                        padding-right: 24px;
                        padding-left: 24px;
                        padding-bottom: 17px;
                        align-content: center;

                    }


                    .card_boxabus_services_desc {
                        text-align: justify;
                        font-size: 13px;
                        padding-top: 11px;
                        color: #374151;
                        line-height: 1.6;
                    }

                    h3.card_boxabus_services_title {
                        display: block;
                        font-size: 16px;
                        font-weight: bold;
                        padding-top: 10px;
                        text-align: center;
                    }

                    .svg_cardboxabus_services {
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        justify-content: center;
                        align-items: center;
                    }

                    .sec_desctiption_and_img_right {
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        justify-content: center;
                        align-items: flex-start;
                    }

              
                    p.aboutus_desc_sec_c {
                        font-family: 'iran';
                        font-size: 14px;
                        line-height: 1.6;
                        color: #1F2937;
                        text-align: justify;
                    }
                    .sec_desctiption_and_img_left img {
                        width: 65% !important;
                    }

                    .sec_desctiption_and_img_left {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: flex-end;
                        align-content: center;
                    }


                    .sec_desctiption_and_img_right_content {
                        display: flex;
                        align-items: flex-start !important;
                        align-content: flex-start !important;
                    }



                    @media only screen and (max-width: 768px) {
                        .sec_desctiption_and_img img {
                            display: none !important;
                        }

                    }
                `}</style>


                <div>
                    <h1 className={"h1-aboutus"}>خدمات بازارانو</h1>
                    <span className={"flex justify-center text-[13px]"}>در اینجا به برخی از خدمات و ویژگی های بازارانو اشاره می شود.</span>

                </div>
                <Box py={4}>


                <Grid className={"sec_desctiption_and_img"} container spacing={4}>
                    <Grid className={"sec_desctiption_and_img_right"} item xs={12} md={6}>
                        <svg className={"mt-[45px] lg:mt[3px]"} width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="72" height="72" rx="18" fill="#FF9828"/>
                            <path
                                d="M36.0002 27.3334H18.6668C17.5176 27.3334 16.4154 27.79 15.6027 28.6026C14.79 29.4153 14.3335 30.5175 14.3335 31.6667V40.3334C14.3335 41.4827 14.79 42.5849 15.6027 43.3975C16.4154 44.2102 17.5176 44.6667 18.6668 44.6667H20.8335V53.3334C20.8335 53.9081 21.0618 54.4592 21.4681 54.8655C21.8744 55.2718 22.4255 55.5001 23.0002 55.5001H27.3335C27.9081 55.5001 28.4592 55.2718 28.8656 54.8655C29.2719 54.4592 29.5002 53.9081 29.5002 53.3334V44.6667H36.0002L46.8335 53.3334V18.6667L36.0002 27.3334ZM42.5002 43.8001L38.1668 40.3334H18.6668V31.6667H38.1668L42.5002 28.2001V43.8001ZM56.5835 36.0001C56.5835 39.7051 54.5035 43.0634 51.1668 44.6667V27.3334C54.4818 28.9584 56.5835 32.3167 56.5835 36.0001Z"
                                fill="white"/>
                        </svg>

                        <span className={"font-bold font-['iran'] text-[18px] mt-[14px] mb-[9px]"}>خدمات مرتبط با سایت</span>
                        <p className={"aboutus_desc_sec_c"}>
                            با استفاده از این خدمات، می‌توانید به راحتی اعتبار خود را افزایش دهید، محصولات خود را به‌طور مؤثرتر تبلیغ کنید و به خریداران عمده دسترسی بیشتری پیدا کنید.با افزایش دیده شدن کسب‌وکار شما به فروش بیشتر کمک می‌کند.
                        </p>
                        <ul className={"[list-style:disc] pr-[27px] pt-[14px] text-[14px] leading-[2.1]"}>
                            <li>ارتقا عضویت</li>
                                <li>احراز هویت</li>
                                <li>نردبان آگهی</li>
                                <li>رزرو تبلیغات</li>
                        </ul>
                    </Grid>

                    <Grid className={"sec_desctiption_and_img_left hide-mobile-bk"} item xs={12} md={6}>
                        <img src={`${imgBaseUrl}images/services/1.png`} alt="Vision" style={{width: '100%'}}/>
                    </Grid>
                </Grid>


                    <Grid className={"sec_desctiption_and_img"} container spacing={4}>

                        <Grid className={"sec_desctiption_and_img_left sec_desctiption_and_img_right_content hide-mobile-bk"} item xs={12} md={6}>
                            <img src={`${imgBaseUrl}images/services/2.png`} alt="Vision" style={{width: '100%'}}/>
                        </Grid>

                        <Grid className={"sec_desctiption_and_img_right "} item xs={12} md={6}>
                            <svg width="72" className={"mt-[45px] lg:mt[3px]"} height="72" viewBox="0 0 72 72" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <rect width="72" height="72" rx="18" fill="#FF9828"/>
                                <path
                                    d="M57.6668 38.1666C57.6668 39.3149 57.2118 40.4199 56.3885 41.2216L55.5002 42.1316C55.3052 35.9349 50.8202 30.8433 44.9052 29.7382L33.8335 18.6666H18.6668V33.8333L29.7385 44.9049C30.8435 50.8199 35.9352 55.3049 42.1318 55.4999L41.2218 56.3882C40.4202 57.2116 39.3152 57.6666 38.1668 57.6666C37.0185 57.6666 35.9352 57.2116 35.1118 56.4099L15.6118 36.9099C14.7885 36.0866 14.3335 34.9816 14.3335 33.8333V18.6666C14.3335 16.2833 16.2835 14.3333 18.6668 14.3333H33.8335C34.9818 14.3333 36.0868 14.7883 36.8885 15.5899L56.3885 35.0899C57.2118 35.9132 57.6668 37.0182 57.6668 38.1666ZM20.8335 24.0833C20.8335 25.8816 22.2852 27.3333 24.0835 27.3333C25.8818 27.3333 27.3335 25.8816 27.3335 24.0833C27.3335 22.2849 25.8818 20.8333 24.0835 20.8333C22.2852 20.8333 20.8335 22.2849 20.8335 24.0833ZM42.7385 32.9883C37.3218 32.9883 32.9885 37.3216 32.9885 42.7382C32.9885 48.1549 37.3218 52.4883 42.7385 52.4883C44.6668 52.4883 46.4002 51.9466 47.9168 51.0149L54.6552 57.6666L57.6668 54.6549L50.9935 47.9166C51.9468 46.4432 52.4885 44.6666 52.4885 42.7382C52.4885 37.3216 48.1552 32.9883 42.7385 32.9883ZM42.7385 37.3216C45.7502 37.3216 48.1552 39.7482 48.1552 42.7382C48.1552 45.7282 45.7502 48.1549 42.7385 48.1549C39.7268 48.1549 37.3218 45.7499 37.3218 42.7382C37.3218 39.7266 39.7485 37.3216 42.7385 37.3216Z"
                                    fill="white"/>
                            </svg>


                            <span
                                className={"font-bold font-['iran'] text-[18px] mt-[14px] mb-[9px]"}>خدمات تامین کالا</span>
                            <p className={"aboutus_desc_sec_c"}>
                                این خدمات، همراه با مشاوره تخصصی، به شما کمک می‌کند تا در خرید عمده محصولات با کیفیت و مطابق با استانداردهای بازار، تجربه‌ای موفق و مطمئن داشته باشید و محصولات عمده خود را آماده و با بهترین شرایط تحویل بگیرید.
                            </p>
                            <ul className={"[list-style:disc] pr-[27px] pt-[14px] text-[14px] leading-[2.1]"}>
                                <li>تامین کالا</li>
                                <li>کنترل کیفیت</li>
                                <li>دریافت مجوزها ،گواهینامه و استانداردها</li>
                                <li>سورت بندی</li>
                                <li>بسته بندی</li>
                                <li>لیبل گذاری</li>
                                <li>و ارائه مشاوره در این خصوص</li>
                            </ul>
                        </Grid>


                    </Grid>


                    <Grid className={"sec_desctiption_and_img mt-[8px]"} container spacing={4}>
                        <Grid className={"sec_desctiption_and_img_right"} item xs={12} md={6}>
                            <svg className={"mt-[45px] lg:mt[3px]"} width="72" height="72" viewBox="0 0 72 72" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <rect width="72" height="72" rx="18" fill="#FF9828"/>
                                <path
                                    d="M53.3332 27.3334H46.8332V18.6667H12.1665V46.8334H16.4998C16.4998 50.4301 19.4032 53.3334 22.9998 53.3334C26.5965 53.3334 29.4998 50.4301 29.4998 46.8334H42.4998C42.4998 50.4301 45.4032 53.3334 48.9998 53.3334C52.5965 53.3334 55.4998 50.4301 55.4998 46.8334H59.8332V36.0001L53.3332 27.3334ZM22.9998 50.0834C21.2015 50.0834 19.7498 48.6317 19.7498 46.8334C19.7498 45.0351 21.2015 43.5834 22.9998 43.5834C24.7982 43.5834 26.2498 45.0351 26.2498 46.8334C26.2498 48.6317 24.7982 50.0834 22.9998 50.0834ZM42.4998 25.1667H38.1665V40.3334H33.8332V25.1667H29.4998V40.3334H25.1665V25.1667H20.8332V40.3334H16.4998V23.0001H42.4998V25.1667ZM48.9998 50.0834C47.2015 50.0834 45.7498 48.6317 45.7498 46.8334C45.7498 45.0351 47.2015 43.5834 48.9998 43.5834C50.7982 43.5834 52.2498 45.0351 52.2498 46.8334C52.2498 48.6317 50.7982 50.0834 48.9998 50.0834ZM46.8332 36.0001V30.5834H52.2498L56.4965 36.0001H46.8332Z"
                                    fill="white"/>
                            </svg>


                            <span
                                className={"font-bold font-['iran'] text-[18px] mt-[14px] mt-[18px]"}>خدمات حمل و نقل</span>
                            <p className={"aboutus_desc_sec_c"}>
                                این خدمات با هدف تحویل ایمن و به‌موقع کالاهای عمده طراحی شده‌اند که فرایند خرید عمده را برای شما آسان و مطمئن می‌سازد و امکان تحویل سریع و امن کالاهای عمده را فراهم می‌کند.
                            </p>
                            <ul className={"[list-style:disc] pr-[27px] pt-[14px] text-[14px] leading-[2.1]"}>
                                <li>حمل و نقل(داخلی و خارجی)</li>
                                <li>بیمه</li>
                                <li>انبارداری ،توزیع و پخش</li>
                                <li>ترخیص و تشریفات گمرکی</li>
                                <li>و ارائه مشاوره در این خصوص</li>
                            </ul>
                        </Grid>

                        <Grid className={"sec_desctiption_and_img_left hide-mobile-bk"} item xs={12} md={6}>
                            <img src={`${imgBaseUrl}images/services/3.png`} alt="Vision" style={{width: '100%'}}/>
                        </Grid>
                    </Grid>




                    <Grid className={"sec_desctiption_and_img"} container spacing={4}>

                        <Grid className={"sec_desctiption_and_img_left sec_desctiption_and_img_right_content"} item xs={12} md={6}>
                            <img src={`${imgBaseUrl}images/services/4.png`} alt="Vision" style={{width: '100%'}}/>
                        </Grid>

                        <Grid className={"sec_desctiption_and_img_right"} item xs={12} md={6}>
                            <svg className={"mt-[45px] lg:mt[3px]"} width="72" height="72" viewBox="0 0 72 72" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <rect width="72" height="72" rx="18" fill="#FF9828"/>
                                <path
                                    d="M52.6832 37.95L40.3332 50.3H35.3498V45.3167L47.6998 32.9667L52.6832 37.95ZM60.0498 36.2167C60.0498 36.8667 59.3998 37.5167 58.7498 38.1667L53.3332 43.5834L51.3832 41.6334L57.0165 36L55.7165 34.7L54.1998 36.2167L49.2165 31.2334L53.9832 26.6834C54.4165 26.25 55.2832 26.25 55.9332 26.6834L58.9665 29.7167C59.3998 30.15 59.3998 31.0167 58.9665 31.6667C58.5332 32.1 58.0998 32.5334 58.0998 32.9667C58.0998 33.4 58.5332 33.8334 58.9665 34.2667C59.6165 34.9167 60.2665 35.5667 60.0498 36.2167ZM16.4998 53.3334V18.6667H31.6665V29.5H42.4998V32.75L46.8332 28.4167V27.3334L33.8332 14.3334H16.4998C14.1165 14.3334 12.1665 16.2834 12.1665 18.6667V53.3334C12.1665 55.7167 14.1165 57.6667 16.4998 57.6667H42.4998C44.8832 57.6667 46.8332 55.7167 46.8332 53.3334H16.4998ZM33.8332 47.05C33.3998 47.05 32.9665 47.2667 32.7498 47.2667L31.6665 42.5H28.4165L23.8665 46.1834L25.1665 40.3334H21.9165L19.7498 51.1667H22.9998L29.2832 45.5334L30.5832 50.5167H32.7498L33.8332 50.3V47.05Z"
                                    fill="white"/>
                            </svg>


                            <span
                                className={"font-bold font-['iran'] text-[18px] mt-[14px] mb-[9px]"}>خدمات قرارداد </span>
                            <p className={"aboutus_desc_sec_c"}>
                                این خدمات فرایند خرید عمده را برای شما امن و قانونی می‌سازد و تمامی جوانب حقوقی و تجاری را  پوشش می‌دهد تا معاملاتی شفاف و امن انجام دهید.
                            </p>

                            <ul className={"[list-style:disc] pr-[27px] pt-[14px] text-[14px] leading-[2.1]"}>
                                <li>همکاری با وکلای حقوقی ،تجاری و بین المللی</li>
                                <li>تنظیم و مشاوره در خصوص قردادهای تجاری و بین المللی (قراردادهای صادراتی ،بروکری،تامین
                                کنندگی ،بیمه و...)
                                </li>
                            </ul>
                        </Grid>


                    </Grid>


                    <Grid className={"sec_desctiption_and_img"} container spacing={4}>
                        <Grid className={"sec_desctiption_and_img_right"} item xs={12} md={6}>
                            <svg className={"mt-[45px] lg:mt[3px]"} width="72" height="72" viewBox="0 0 72 72"
                                 fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <rect width="72" height="72" rx="18" fill="#FF9828"/>
                                <path
                                    d="M50.5602 41.98C51.3185 40.1383 51.7302 38.1667 51.7302 36C51.7302 34.44 51.4918 32.945 51.0802 31.5583C49.6718 31.8833 48.1985 32.0567 46.6602 32.0567C40.0302 32.0567 34.1585 28.785 30.5835 23.7367C28.6552 28.4167 24.9718 32.23 20.3352 34.31C20.2485 34.8517 20.2485 35.4367 20.2485 36C20.2485 40.1776 21.908 44.1841 24.8621 47.1381C27.8161 50.0921 31.8226 51.7517 36.0002 51.7517C38.2752 51.7517 40.4635 51.2533 42.4352 50.365C43.6702 52.7267 44.2335 53.8967 44.1902 53.8967C40.6368 55.0883 37.8852 55.6733 36.0002 55.6733C30.7568 55.6733 25.7518 53.615 22.0685 49.91C19.8152 47.6567 18.1468 44.905 17.2152 41.915H14.3335V32.0567H16.6952C18.5152 23.0867 26.4668 16.3267 36.0002 16.3267C41.2002 16.3267 46.2052 18.385 49.9102 22.09C52.6618 24.82 54.5035 28.3083 55.2618 32.0567H57.6668V41.785V41.8283V41.915H57.5368L49.8235 49L38.3402 47.7V44.0817H48.8052L50.5602 41.98ZM30.0852 35.5017C30.7352 35.5017 31.3635 35.7617 31.8185 36.2383C32.2735 36.6933 32.5335 37.3217 32.5335 37.9717C32.5335 38.6217 32.2735 39.25 31.8185 39.705C31.3635 40.16 30.7352 40.42 30.0852 40.42C28.7202 40.42 27.6152 39.3367 27.6152 37.9717C27.6152 36.6067 28.7202 35.5017 30.0852 35.5017ZM41.8935 35.5017C43.2585 35.5017 44.3418 36.6067 44.3418 37.9717C44.3418 39.3367 43.2585 40.42 41.8935 40.42C40.5285 40.42 39.4235 39.3367 39.4235 37.9717C39.4235 37.3166 39.6837 36.6883 40.1469 36.2251C40.6102 35.7619 41.2384 35.5017 41.8935 35.5017Z"
                                    fill="white"/>
                            </svg>


                            <span className={"font-bold font-['iran'] text-[18px] mt-[14px] mb-[9px]"}>سایر خدمات</span>
                            <p className={"aboutus_desc_sec_c"}>
                                این خدمات با  هدف تسهیل و بهبود فرایند خرید عمده و صادرات طراحی شده‌اند.که به توسعه و موفقیت تجارت شما در بازارهای بین‌المللی کمک می‌کند.
                            </p>

                            <ul className={"[list-style:disc] pr-[27px] pt-[14px] text-[14px] leading-[2.1]"}>
                                <li>بروکری</li>
                                <li>تنظیم کاتولوگ صادراتی</li>
                                <li>تبلیغ و انتشار آگهی در گروه‌ها و سایت های خارجی</li>
                                <li>مترجم زبان کشور هدف</li>
                                <li>تیم تورهای تجاری برای تجار و صادرکنندگان</li>
                                <li>آموزش و مشاوره در خصوص صادرات</li>
                            </ul>

                        </Grid>

                        <Grid className={"sec_desctiption_and_img_left"} item xs={12} md={6}>
                            <img src={`${imgBaseUrl}images/services/5.png`} alt="Vision" style={{width: '100%'}}/>
                        </Grid>
                    </Grid>


                </Box>


            </Master_Front>

        </Fragment>
    );
}

export default Services;